import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import loginImage from "../../assets/images/login.png";
import LogoWhite from "../../assets/images/LogoWhite.svg";
import infocircle from "../../assets/images/infocircle.svg";
import PrimecareLogo from "../../assets/images/PrimecareLogo.svg";
import { useCommonMessage } from "../../common/CommonMessage";
import Loader from "../Loder/loader";
import { STATUS_CODE } from "../../common";
import {
  guestUserPhoneLoginHandler,
  guestUserPhoneLoginSliceAction,
} from "../../redux/action/guestUserAction/guestUserPhoneLogin";
import {
  getCurrentStepsHandler,
  getCurrentStepsSliceAction,
} from "../../redux/action/guestUserAction/getCurrentSteps";
import {
  GUEST_EDUCATIONAL_BACK_DEFAULT,
  GUEST_ENROLLMENT_PATHS,
  guestEnrollmentPathFromStep,
  normalizeGuestStepKey,
} from "../../common/guestEnrollmentFlow";
import { setItem } from "../../common/localStorage";
import { GUEST_LOGIN_RESPONSE_KEY } from "../../common/authSession";

const VerifyPhoneNumber = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const messageApi = useCommonMessage();

  const selectedNumber = location?.state?.selectedNumber;
  const loginContext = location?.state?.loginContext;
  const [phoneNumber, setPhoneNumber] = useState("");
  const selectedNumberLast4 = useMemo(() => {
    const digitsOnly = String(selectedNumber || "").replace(/\D/g, "");
    if (digitsOnly.length >= 4) return digitsOnly.slice(-4);
    return "0001";
  }, [selectedNumber]);
  const guestUserPhoneLoginSelector = useSelector(
    (state) => state?.guestUserPhoneLogin,
  );
  const getCurrentStepsSelector = useSelector(
    (state) => state?.getCurrentSteps,
  );

  const handleRedirect = useCallback((enumType) => {
    return guestEnrollmentPathFromStep(enumType);
  }, []);

  useEffect(() => {
    dispatch(guestUserPhoneLoginSliceAction.guestUserPhoneLoginSliceReset());
    dispatch(getCurrentStepsSliceAction.getCurrentStepsSliceReset());
  }, [dispatch]);

  useEffect(() => {
    if (!selectedNumber || !loginContext?.ssn || !loginContext?.dob) {
      navigate("/guest-user/number-listing", { replace: true });
    }
  }, [selectedNumber, loginContext, navigate]);

  const handleVerifyPhone = () => {
    if (!phoneNumber?.trim()) {
      messageApi.open({
        type: "error",
        content: t("Please enter your phone number."),
      });
      return;
    }
    dispatch(
      guestUserPhoneLoginHandler({
        ssn: loginContext?.ssn,
        dob: loginContext?.dob,
        phoneNumber: phoneNumber.trim(),
        deviceType: "ANDROID",
        deviceId: "device123",
        modelName: "Pixel 7",
        deviceName: "My Phone",
        brand: "Google",
        fcmToken: "sample-fcm-token",
      }),
    );
  };
  useEffect(() => {
    const statusCode = guestUserPhoneLoginSelector?.data?.statusCode;
    const responseMessage = guestUserPhoneLoginSelector?.data?.message;

    if (statusCode === STATUS_CODE.OK) {
      const loginResponse = guestUserPhoneLoginSelector?.data?.data;
      if (loginResponse != null) {
        setItem(GUEST_LOGIN_RESPONSE_KEY, loginResponse);
      }
      messageApi.open({
        type: "success",
        content: responseMessage,
      });
      dispatch(getCurrentStepsHandler());
      dispatch(guestUserPhoneLoginSliceAction.guestUserPhoneLoginSliceReset());
    } else if (
      statusCode === STATUS_CODE.NOT_FOUND ||
      statusCode === STATUS_CODE.BAD_REQUEST ||
      statusCode === STATUS_CODE.UNAUTHORIZED ||
      statusCode === STATUS_CODE.FORBIDDEN
    ) {
      messageApi.open({
        type: "error",
        content: responseMessage,
      });
      dispatch(guestUserPhoneLoginSliceAction.guestUserPhoneLoginSliceReset());
    } else if (guestUserPhoneLoginSelector?.message) {
      messageApi.open({
        type: "error",
        content: guestUserPhoneLoginSelector?.message,
      });
      dispatch(guestUserPhoneLoginSliceAction.guestUserPhoneLoginSliceReset());
    }
  }, [guestUserPhoneLoginSelector, dispatch, messageApi]);

  useEffect(() => {
    if (
      getCurrentStepsSelector?.isLoading ||
      getCurrentStepsSelector?.data ||
      !getCurrentStepsSelector?.message
    ) {
      return;
    }
    messageApi.open({
      type: "error",
      content: getCurrentStepsSelector.message,
    });
    dispatch(getCurrentStepsSliceAction.getCurrentStepsSliceReset());
  }, [getCurrentStepsSelector, dispatch, messageApi]);

  useEffect(() => {
    if (getCurrentStepsSelector?.isLoading) {
      return;
    }

    const payload = getCurrentStepsSelector?.data;
    const statusCode = payload?.statusCode;
    const step = payload?.data?.currentStep;
    if (statusCode !== STATUS_CODE.OK || !step) {
      return;
    }

    const route = handleRedirect(step);
    const stepKey = normalizeGuestStepKey(step);
    const navOpts = { replace: true };

    if (stepKey === "ENROLLMENT_AGGREMENT") {
      navOpts.state = { enrollmentDecision: "yes" };
    }
    if (stepKey === "ENROLLMENT_DECLINED") {
      navOpts.state = { enrollmentDecision: "no" };
    }
    if (stepKey === "COMPLETED") {
      navOpts.state = { enrollmentDecision: "yes" };
    }
    if (route === GUEST_ENROLLMENT_PATHS.educational) {
      navOpts.state = {
        ...navOpts.state,
        guestEducationalBackTo: GUEST_EDUCATIONAL_BACK_DEFAULT,
      };
    }

    dispatch(getCurrentStepsSliceAction.getCurrentStepsSliceReset());
    navigate(route, navOpts);
  }, [getCurrentStepsSelector, handleRedirect, navigate, dispatch]);

  // const navigateToSupportRequest = () => {
  //   navigate("/support-request");
  // };


  return (
    <>
      {(guestUserPhoneLoginSelector?.isLoading ||
        getCurrentStepsSelector?.isLoading) && (
          <Loader loaderTransform="loaderTransform" />
        )}
      <div className="loginFlex pc">
        <div className="w-50 h-100 position-relative mobileHide">
          <img src={loginImage} alt="" className="w-100 h-100 object-cover" />
          <img src={LogoWhite} alt="" className="loginLogo" />
          <div className="loginText">
            <h2 className="fs-32 text-white fw-700">
              {t("Prime Care")}{" "}
              <span className="fs-28 text-white fw-300 gbo">
                {t("Provides")} {t("Nationwide")} <br />{" "}
                {t("Direct Primary Care")}
              </span>
            </h2>
          </div>
        </div>
        <div className="d-flex align-center justify-center w-lg-50 loginside">
          <div className="mx-420 mx-auto">
            <div className="text-center mb-40 mobileShow">
              <img src={PrimecareLogo} alt="" />
            </div>
            <h1 className="fs-36 mb-8 text-lg-center tgb">{t("Login")}</h1>
            <h2 className="fs-28 mb-40 text-lg-center tgb">
              {t("to complete the Education")}
            </h2>

            <div className="mb-40">
              <h2 className="fs-16 mb-10">{t("Enter your phone Number")}</h2>
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                className="inputField mb-10"
                value={phoneNumber}
                onChange={(event) =>
                  setPhoneNumber(event.target.value.replace(/\D/g, ""))
                }
                placeholder={t("+1 (XXX) XXX-XXXX")}
                autoComplete="off"
              />
              <div
                className="fs-14 fw-500 gap-4 lineheight-18 d-flex align-items-center mb-20"
                style={{ color: "#8697B1" }}
              >
                <img src={infocircle} alt="" />
                {t("Enter your full number ending with {{last4}} to verify", {
                  last4: selectedNumberLast4,
                })}
              </div>

              <button
                className={`primaryButton w-100 mb-20 cursor-pointer fs-18 ${!phoneNumber?.trim() ? "disable not-allowed" : "cursor-pointer"}`}
                type="button"
                onClick={handleVerifyPhone}
                disabled={!phoneNumber?.trim()}
              >
                {t("Verify phone number")}
              </button>
            </div>

            <div className="text-center mb-40">
              {t("Already a member?")}{" "}
              <span onClick={() => navigate("/login")} className="primaryColor cursor-pointer underline">
                {t("Login")}
              </span>
            </div>

            {/* <div className="mb-30 text-lg-center text-center">
            {t("By Signing in you agree to our")}{" "}
            <span
              className="gm cursor-pointer"
              onClick={() =>
                window.open(
                  "https://primecaregs.com/notice-of-privacy-practices-for-primecare/",
                  "_blank",
                )
              }
            >
              {t("Privacy Policy")}
            </span>
          </div>
          <div
            className="text-center text-underline text-underline cursor-pointer"
            onClick={navigateToSupportRequest}
          >
            {t("Having trouble signing in?")}
          </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyPhoneNumber;
